<template>
  <div class="shop">
    <!-- @getSearch = "getSearch" -->
    <nav-header @getTelPhone = "getTelPhone" @getSearch = "getSearch" ></nav-header>
    <div class="sub_title">
      <div class="sub-left" @click="showkindList">
        <span></span>全部分类
      </div>
      <div class="sub-right">
        <ul>
          <li class="kind-item" v-for="(item ,index ) in navkindList" :key="index" >
            <a :class="kindName == (index+1) ? 'active' : ''" href="javascript:;" @click="kindInfo(index + 1,1,1)" >{{classify}}{{item}}</a>
          </li>
        </ul>
      </div>
    </div>
    <cube-scroll
      ref="scroll"
      :data="items"
      :options="options"
      @pulling-down="onPullingDown"
      @pulling-up="onPullingUp" class="page_scroll">
      <div class="scroll-box">
        <div class="sub—content">
          <ul v-show="isActive == 0">
            <li class="noDataTip notice" v-if="kindList.length == 0">
              <dl>
                <dt></dt>
                <dd>暂无数据</dd>
              </dl>
            </li>
            <li v-for="(item, index) in kindList" :key="index">
              <router-link :to="{ name: 'shopDetail', params: { 'commodity_id': item.commodity_id }}">
                <div class="sub-hot-list" :style="`background-image:url(${item.home_page})`">
                  <!-- :style="`background-image:url(${item.home_page})`" -->
                  <div class="sub-hot-list-left" >
                    <h5>{{item.title}}</h5>
                    <p class="sub-con">{{item.title1}}</p>
                    <p class="sub-pay" @click="payGood(item.commodity_id)"><span>立即购买</span><span>￥{{item.money}}</span></p>
                  </div>
                  <div class="sub-hot-list-img" >
                    <img :src="item.home_page1" alt="">
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
          <ul v-show="isActive == 1">
            <li class="noDataTip notice" v-if="hotList.length == 0">
              <dl>
                <dt></dt>
                <dd>暂无数据</dd>
              </dl>
            </li>
            <li v-for="(item, index) in hotList" :key="index">
              <router-link :to="{ name: 'shopDetail', params: { 'commodity_id': item.commodity_id }}">
                <div class="sub-hot-list" :style="`background-image:url(${item.home_page})`">
                  <!-- :style="`background-image:url(${item.home_page})`" -->
                  <div class="sub-hot-list-left" >
                    <h5>{{item.title}}</h5>
                    <p class="sub-con">{{item.title1}}</p>
                    <p class="sub-pay" @click="payGood(item.commodity_id)"><span>立即购买</span><span>￥{{item.money}}</span></p>
                  </div>
                  <div class="sub-hot-list-img" >
                    <img :src="item.home_page1" alt="">
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
          <ul v-show="isall == 2">
            <li class="noDataTip notice" v-if="allList.length == 0">
              <dl>
                <dt></dt>
                <dd>暂无数据</dd>
              </dl>
            </li>
            <li v-for="(item, index) in allList" :key="index">
              <router-link :to="{ name: 'shopDetail', params: { 'commodity_id': item.commodity_id }}">
                <div class="sub-hot-list" :style="`background-image:url(${item.home_page})`">
                  :style="`background-image:url(${item.home_page})`"
                  <div class="sub-hot-list-left" >
                    <h5>{{item.title}}</h5>
                    <p class="sub-con">{{item.title1}}</p>
                    <p class="sub-pay" @click="payGood(item.commodity_id)"><span>立即购买</span><span>￥{{item.money}}</span></p>
                  </div>
                  <div class="sub-hot-list-img" >
                    <img :src="item.home_page1" alt="">
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </cube-scroll>
  </div>
</template>
<script>
import navHeader from '../components/nav/nav'
export default {
  name: 'shop',
  data (){
    return {
      type: this.$route.params.type, //用户角色类型
      options: {
        pullUpLoad: {
          threshold: 60,
          txt: {
            more: '加载更多',
            noMore: '没有更多了'
          }
        },
        pullDownRefresh: {
          threshold: 60,
          txt: '刷新成功'
        }
      },
      isall: false,
      isShowList: false,
      isActive: 1, //类别显示状态， 0新品，1热销
      pageNum: 1,
      allpage: null,
      hotList: [], //热销
      kindList: [],//分类 新品
      items:[],
      allList: [],
      navkindList: [
        '检测类',
        '保存类',
        '保管类'
      ],
      kindName: '', //分类记录名称
      isSearch : false, //是否搜索
      searchText: '', //搜索内容
      classify: ''
    }
  },
  mounted(){
    // this.$loading.show()
  },
  created () {

   // this.getSearch('', '', 1, 1)
  },
  methods: {
    // 搜索
    getSearch (value, kindName = '', pageNum = 1, type=1) {
      this.isSearch = true
      this.searchText = value
      let _this = this
      this.$http.api.shop({
        page: pageNum ,
        size: 10 ,
        name: value ? value : '' ,
        classify: this.kindName ? this.kindName : kindName ,
        commodityType: ''
      }).then( result => {
        this.$loading.hide()
        _this.allpage = Math.ceil(result.total/10)
        let data = result.rows
        if (type === 1) {
          if(_this.isActive == 0){
            _this.kindList = [...data]
          }else if(_this.isActive == 1){
            _this.hotList = [...data]
          }
          _this.pageNum = 2
          _this.$refs.scroll.forceUpdate()

        } else {
          if (data.length > 0 && _this.pageNum < _this.allpage) {
            if(_this.isActive == 0){
              _this.kindList = _this.kindList.concat(data)
            }else if(_this.isActive == 1){
              _this.hotList = _this.hotList.concat(data)
            }
            //  _this.kindList = _this.kindList.concat(data)
            _this.pageNum = _this.pageNum + 1
            _this.$refs.scroll.forceUpdate()
          }
        }
      })
      if( _this.pageNum > _this.allpage){
        setTimeout(function () {
          _this.$refs.scroll.forceUpdate()
        }, 300)
      }

      if( _this.pageNum > _this.allpage){
        setTimeout(function () {
          _this.$refs.scroll.forceUpdate()
        }, 300)
      }
    },
    showkindList () {
      this.isShowList = !this.isShowList
    },
    // 点击分类
    kindInfo (name, pageNum, type) {
      // this.allList = []
      this.isSearch = false
      this.$loading.show()
      this.isall = true
      this.isShowList = false
      let _this = this
      this.kindName = name
      if(this.type == 0 || this.type == 2) {
        this.$http.api.shop({
          page: pageNum,
          size: 10,
          name: this.searchText ? this.searchText : '',
          classify: name,
          commodityType: ''
        }).then( result => {
          this.$loading.hide()
          _this.allpage = Math.ceil(result.total/10)
          // this.hotList = result.rows
          //  this.allList = [...result.rows]
          let data = result.rows
          if (type === 1) {
            _this.allList = [...data]
            _this.$refs.scroll.forceUpdate()
            _this.pageNum = 2
            // 条件筛选
            if(_this.isActive == 0){
              _this.kindList = _this.allList
            }else if(_this.isActive == 1) {
              _this.hotList = _this.allList
            }
          } else {
            if (data.length > 0 && _this.pageNum < _this.allpage) {
              _this.allList = _this.allList.concat(data)
              _this.pageNum = _this.pageNum + 1
              if(_this.isActive == 0){
                _this.kindList = _this.allList
              }else if(_this.isActive == 1){
                _this.hotList = _this.allList
              }
              _this.$refs.scroll.forceUpdate()
            }
          }
        })
        if( _this.pageNum > _this.allpage) {
          setTimeout(function () {
            _this.$refs.scroll.forceUpdate()
          }, 300)
        }
      } else if(this.type == 1) {

        this.$http.api.recommendShop({
          page: pageNum,
          size: 10,
          name: this.searchText ? this.searchText: '',
          classify: name,
          commodityType: ''
        }).then( result => {
          this.$loading.hide()
          // this.hotList = result.rows
          _this.allpage = Math.ceil(result.total/10)
          //  this.allList = [...result.rows]
          let data = result.rows
          if (type === 1) {
            _this.allList = [...data]
            _this.$refs.scroll.forceUpdate()
            _this.pageNum = 2
            if(_this.isActive == 0){
              _this.kindList = _this.allList
            }else if(_this.isActive == 1){
              _this.hotList = _this.allList
            }
          } else {
            if (data.length > 0 && _this.pageNum <= _this.allpage) {
              _this.allList = _this.allList.concat(data)
              _this.pageNum = _this.pageNum + 1
              if(_this.isActive == 0){
                _this.kindList = _this.allList
              }else if(_this.isActive == 1){
                _this.hotList = _this.allList
              }
              _this.$refs.scroll.forceUpdate()
            }
          }
          // console.log(allList)
        })
        if( _this.pageNum > _this.allpage){
          setTimeout(function () {
            _this.$refs.scroll.forceUpdate()
          }, 300)
        }
      }
    },
    // 立即购买
    payGood (shopId) {
      this.$router.push({name: 'payGoods',query: {'commodity_id': shopId }})
    },
    onPullingDown () {
      // this.isLoading = false
      let _this = this
      _this.getSearch(_this.searchText,_this.kindName,1,1)
    },
    onPullingUp () {
      let _this = this
      setTimeout(function () {
        if(this.isSearch){
          _this.getSearch(_this.searchText,_this.kindName,_this.pageNum, 2)
        }else{
          _this.getSearch(_this.searchText,_this.kindName,_this.pageNum, 2)
        }
      }, 800)
    },
    getTelPhone() {
      // 点击电话弹窗
      this.$createDialog({
        type: 'confirm',
        // icon: 'cubeic-alert',
        title: '4006-878-036',
        // content: '我是内容',
        confirmBtn: {
          text: '通话',
          active: true,
          disabled: false,
          href: 'tel:4006-878-036'
        },
        cancelBtn: {
          text: '取消',
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: () => {
          window.location.href = 'tel:4006-878-036'
        },
        onCancel: () => {
        }
      }).show()
    }
  },
  components: {
    navHeader
  }
}
</script>
<style lang="less" scoped>
  .page_scroll {
    /* width: 100%; */
    position: absolute;
    top: 91px;
    left: 0;
    bottom: 0px;
    height: auto;
  }
  .noDataTip{
    width: 100%;
    text-align: center;
  }
  .scroll-box{
    width: 100%;
    position: relative;
    // top: 91px;
    // bottom: 100px;
  }
  .shop {
    width: 100%;
    .sub_title{
      width: 100%;
      height: 30px;
      line-height: 30px;
      color: #999;
      position: relative;
      top: 61px;
      // margin-top: 41px;
      .sub-left{
        width: 20%;
        background: #fff;
        color: #60B0E3;
        font-size: 10px;
        float: left;
        span {
          display: block;
          width: 20px;
          height: 10px;
          margin-top: 8.5px;
          margin-right: 2px;
          color: #60b0e3;
          font-size: 10px;
          background: url(../assets/images/yi8.png) 10px center no-repeat #fff;
          -webkit-background-size: auto 10px;
          background-size: auto 10px;
          float: left;
          // padding: 0 5px 0 12px;
        }
      }
      .sub-right {
        width: 80%;
        height: 100%;
        box-sizing: border-box;
        background: rgba(241,241,241,.2);
        border-bottom: 1px solid #E0E0E0;
        border-left: 1px solid #E0E0E0;
        ul {
          width: 100%;
          height: 100%;
          li {
            height: 100%;
            float: right;
            padding: 0px 9px;
            box-sizing: border-box;
            border-bottom:1px solid transparent;
            // border-bottom: 1px solid #60B0E3;
            // &:nth-child(1){
            margin-right: 15px;
            // }
          }
          .active {
            border-bottom: 1px solid #60B0E3;
            color:rgba(96,176,227,1);
            font-weight:bold;
            text-decoration: none;
          }
        }
      }
    }
    .allKinds{
      width: 70%;
      height: 50px;
      overflow: scroll;
      position: absolute;
      top: 91px;
      padding: 0 15px;
      box-sizing: border-box;
      z-index: 999;
      background: #FFF;
      border-radius: 0 0 5px 5px;
      .allkinds-list {
        width: 100%;
        padding: 15px 0;
        li{
          // width: 20%;
          padding: 2px 15px;
          border: 1px solid #60B0E3;
          float: left;
          border-radius: 10px;
          margin: 0 3px 5px;
          text-align: center;
          a{

          }
        }
      }
    }
    .upDown-enter-active, .upDown-leave-active {
      transition: all .8s;
    }
    .upDown-enter{
      height: 0px;
    }
    .upDown-leave-to /* .fade-leave-active below version 2.1.8 */ {
      // opacity: 0;
      height: 0px;
    }
    .sub—content {
      width: 100%;
      padding: 14px 0;
      box-sizing: border-box;
      background: #fff;
      margin-bottom:55px;
      ul {
        width: 100%;
        padding: 0 15px;
        box-sizing: border-box;
        li {
          width: 100%;
          margin-bottom: 10px;
          .sub-hot-list {
            // position: relative;
            padding: 24px 100px 13px 18px;
            position: relative;
            color: #fff;
            font-size: 12px;
            border-radius: 5px;
            background: url(../assets/images/yp9.jpg) no-repeat center center;
            background-size: cover;
            .sub-hot-list-left {
              color:#60B0E3;
              h5 {
                width:100%;
                height:32px;
                font-size:16px;
                font-family:MicrosoftYaHei;
                font-weight:400;
                color:rgba(255,255,255,1);
                line-height:15px;
                color:#60B0E3;
              }
              .sub-con {
                // height: 60px;
                width: 100%;
                font-size:10px;
              }
              .sub-pay {
                margin-top: 18px;
                span:nth-child(1){
                  width:66px;
                  height:24px;
                  line-height:24px;
                  display: inline-block;
                  color: #60B0E3;
                  background:rgba(255,255,255,1);
                  border-radius:12px;
                  text-align: center;
                }
                span:nth-child(2){
                  height:24px;
                  line-height:24px;
                  font-size: 18px;
                  display: inline-block;
                  text-align: center;
                  margin-left: 13px;
                }
              }
            }
            .sub-hot-list-img{
              position: absolute;
              top: 27px;
              right: 20px;
              width: 72px;
              height: 73px;
              background-position: center center;
              background-repeat: no-repeat;
              -webkit-background-size: 100% auto;
              background-size: 100% auto;
            }
          }
        }
      }
    }
  }
</style>


